import { create } from "zustand";
import { AdminRole, AdminTraining } from "../admin/entities/AdminRole";

interface AdminStore {
  adminTrainings: AdminTraining[];
  setAdminTrainings: (adminTrainings: AdminTraining[]) => void;
  getRoleForTraining: (trainingId: string | number | null | undefined) => AdminRole | null;
  reset: () => void;
}

export const useAdminStore = create<AdminStore>()((set, get) => ({
  adminTrainings: [],
  setAdminTrainings: (adminTrainings) => set({ adminTrainings }),
  getRoleForTraining: (trainingId) => {
    if (!trainingId) return null;
    const assignment = get().adminTrainings.find(
      (entry) => entry.trainingId === String(trainingId),
    );
    return assignment?.role ?? null;
  },
  reset: () => set({ adminTrainings: [] }),
}));
